import * as React from "react"
import { toast } from "sonner"

export function useCopyCommand() {
  const [copiedId, setCopiedId] = React.useState<number | null>(null)

  const copy = React.useCallback(async (id: number, command: string) => {
    try {
      await navigator.clipboard.writeText(command)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = command
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    setCopiedId(id)
    toast.success("복사됐어요!", { description: command })
    setTimeout(() => {
      setCopiedId((current) => (current === id ? null : current))
    }, 1500)
  }, [])

  return { copiedId, copy }
}
